import { useTaxState } from '@/app/components/context/tax-state-context';
import { Button } from '@av/ui/button';
import { TAX_HIGH_FACTOR } from '@av/utils';
import { X } from 'lucide-react';
import React from 'react';
import { useSearchParams, useRouter, usePathname } from 'next/navigation';

const RefinementValues = () => {
  const { isTaxIncluded } = useTaxState();
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const min = searchParams.get('min') ? Number(searchParams.get('min')) * 100 : undefined;
  const max = searchParams.get('max') ? Number(searchParams.get('max')) * 100 : undefined;

  const specificationValues = Object.entries(
    searchParams
      .get('specificaties')
      ?.split(',')
      .reduce(
        (acc, curr) => {
          const [key, value] = curr.split(':');
          if (key && value) {
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key]?.push(value);
          }

          return acc;
        },
        {} as Record<string, string[]>
      ) || {}
  );

  const removeRefinements = () => {
    const params = new URLSearchParams(searchParams);
    params.delete('min');
    params.delete('max');
    params.delete('specificaties');
    params.delete('pagina');
    router.push(`${pathname}?${params.toString()}`);
  };
  const removeRefinement = (key: string) => {
    const params = new URLSearchParams(searchParams);
    if (key === 'price') {
      params.delete('min');
      params.delete('max');
    } else {
      const currentSpecs = params.get('specificaties')?.split(',') || [];
      const updatedSpecs = currentSpecs.filter((spec) => !spec.startsWith(`${key}:`));
      if (updatedSpecs.length > 0) {
        params.set('specificaties', updatedSpecs.join(','));
      } else {
        params.delete('specificaties');
      }
    }
    params.delete('pagina');
    router.push(`${pathname}?${params.toString()}`);
  };

  const renderPriceButton = () => {
    if (min !== undefined || max !== undefined) {
      const minValue =
        min !== undefined
          ? Math.round((min * (isTaxIncluded ? 1 + TAX_HIGH_FACTOR : 1)) / 100)
          : undefined;
      const maxValue =
        max !== undefined
          ? Math.round((max * (isTaxIncluded ? 1 + TAX_HIGH_FACTOR : 1)) / 100)
          : undefined;
      const priceText =
        minValue && maxValue
          ? `€ ${minValue} - € ${maxValue}`
          : minValue
            ? `>= € ${minValue}`
            : maxValue
              ? `<= € ${maxValue}`
              : '';

      return (
        <Button
          key="price"
          variant="outline"
          className="rounded-full bg-gray-200 text-sm"
          size="sm"
          onClick={() => removeRefinement('price')}
        >
          Prijs: {priceText} <X className="ml-1 size-4" />
        </Button>
      );
    }

    return null;
  };

  const renderSpecificationButtons = () => {
    return specificationValues.map(([key, value]) => (
      <Button
        key={key}
        variant="outline"
        className="rounded-full bg-gray-200 text-sm"
        size="sm"
        onClick={() => removeRefinement(key)}
      >
        {key}: {value.join(' | ')} <X className="ml-1 size-4" />
      </Button>
    ));
  };

  return (
    <div className="flex flex-wrap gap-2">
      {renderPriceButton()}
      {renderSpecificationButtons()}
      {!!(specificationValues.length || min || max) && (
        <Button
          variant="outline"
          className="rounded-full bg-gray-200 text-sm"
          size="sm"
          onClick={removeRefinements}
        >
          Filters wissen <X className="ml-1 size-4" />
        </Button>
      )}
    </div>
  );
};

export default RefinementValues;
